module.exports = __webpack_public_path__ + "static/img/cycleAI-50.23b87ae.svg";